<template>
  <div>
    <div id="sidebar-right">
      <h3>Liste aller deiner Freunde</h3>
      Dein Freundschaftscode: {{ myFriendCode }}
      <hr>
      <b-list-group v-if="friendRequests.length > 0">
        Freundschaftsanfragen
        <b-list-group-item class="d-flex justify-content-between align-items-center">Alle Annehmen
          <b-button variant="success" @click="acceptAllFriendRequest">
            <b-icon-check-2-all/>
          </b-button>
        </b-list-group-item>
        <b-list-group-item v-for="friendRequest in friendRequests" v-bind:key="friendRequest.friendCode"
                           class="d-flex justify-content-between align-items-center">
          {{ friendRequest.username }}

          <div>
            <b-button variant="success" @click="acceptFriendRequest(friendRequest.friendCode)">
              <b-icon-check-2/>
            </b-button>
          </div>
        </b-list-group-item>
      </b-list-group>

      <b-list-group v-if="friends.length > 0">
        <h5>Freunde</h5>
        <div v-for="friend in friends" v-bind:key="friend.friendCode">
          <b-list-group-item class="d-flex justify-content-between align-items-center"
                             @mouseenter="hovered(friend.friendCode)" @mouseleave="hovered(friend.friendCode)">
            {{ friend.name ? friend.name : friend.username }}
            <div>
              <b-avatar v-if="!showDelete(friend.friendCode)"
                        :src="friend.profilePicture.id> 1 ? friend.profilePicture.path : ''"/>
              <b-button v-if="showDelete(friend.friendCode)" variant="danger" @click="prepareDeleteFriend(friend)">
                <b-icon-x/>
              </b-button>
            </div>

          </b-list-group-item>
        </div>
      </b-list-group>
      <b-list-group v-if="friendRequestsSend.length > 0">
        <h5>Ausstehende Anfragen</h5>
        <b-list-group-item class="d-flex justify-content-between align-items-center"
                           v-for="friendRequestSend in friendRequestsSend" v-bind:key="friendRequestSend.friendCode"
                           @mouseenter="hoveredFriendRequest(friendRequestSend.friendCode)"
                           @mouseleave="hoveredFriendRequest(friendRequestSend.friendCode)">
          {{ friendRequestSend.username }}
          <div>

            <b-button v-if="!showDeleteRequest(friendRequestSend.friendCode)" variant="primary" disabled>
              <b-icon-clock/>
            </b-button>
            <b-button v-if="showDeleteRequest(friendRequestSend.friendCode)" variant="danger"
                      @click="cancelFriendRequest(friendRequestSend.friendCode)">
              <b-icon-x/>
            </b-button>
          </div>
        </b-list-group-item>

      </b-list-group>
      <b-input-group class="username-or-code-input">
        <b-form-input v-model="newFriendName" name="newFriend" id="newFriend" placeholder="Username/Code eingeben"/>
        <b-input-group-append>
          <b-button variant="success" @click="sendRequest">
            <b-icon icon="plus"></b-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
    <b-modal ref="delete-modal" title="Sind Sie sich sicher?" @hidden="resetDeleteFriend"
             @ok="deleteFriend">
      <div class="text-center">
        Wollen Sie {{ friendToBeDeleted.name ? friendToBeDeleted.name : friendToBeDeleted.username }} wirklich aus Ihrer
        Freundesliste entfernen?
      </div>
    </b-modal>
  </div>
</template>

<script>


import {BIconCheck2, BIconCheck2All, BIconClock, BIconX} from "bootstrap-vue";
import {friendService} from "@/services/friend.service";
import {utilsService} from "@/services/utils.service";

export default {
  name: 'Friends',
  components: {
    BIconCheck2,
    BIconCheck2All,
    BIconClock,
    BIconX
  },
  data() {
    return {
      newFriendName: "",
      friendRequestMethod: "code",
      friends: [],
      friendRequestsSend: [],
      friendRequests: [],
      myFriendCode: "",
      friendToBeDeleted: {},
      hoveredList: [],
      hoveredListRequest: []
    }
  },
  created() {
    this.loadFriends()
  },
  methods: {
    loadFriends() {
      friendService.getFriends().then(res => {

        this.friends = res.friends;
        this.friends.forEach(friend => this.hoveredList[friend.friendCode] = false);
        this.friendRequests = res.friendRequests;
        this.friendRequests.forEach(friendRequest => this.hoveredList[friendRequest.friendCode] = false);
        this.friendRequestsSend = res.friendRequestsSend;
        this.myFriendCode = res.friendCode;
      });
    },
    sendRequest() {
      if(this.newFriendName.length <= 0) {
        return
      }
      let mode = "code";
      if(isNaN(this.newFriendName)) {
        mode="username"
      }
      friendService.sendFriendRequest(this.newFriendName, mode)
          .then((res) => {
            this.newFriendName = "";
            if (res.code === 1) {
              this.$root.$bvToast.toast(`Freundschaftsanfrage wurde gesendet!`, {
                title: 'Erfolgreich!',
                autoHideDelay: 5000,
                variant: "success"
              });
            }
            this.loadFriends()
          })
          .catch(res => {
            if (res.response.code === 11) {
              this.$root.$bvToast.toast(`Freund konnte nicht hinzugefügt werden!`, {
                title: 'Benutzer wurde nicht gefunden!',
                autoHideDelay: 5000,
                variant: "warning"
              });
            }
          })
    },
    acceptFriendRequest(id) {
      friendService.acceptFriendRequest(id).then(() => this.loadFriends())
    },
    acceptAllFriendRequest() {
      this.friendRequests.forEach(friend => this.acceptFriendRequest(friend.friendCode));
    },
    prepareDeleteFriend(friend) {
      this.friendToBeDeleted = friend;
      this.$refs['delete-modal'].show();

    },
    deleteFriend() {
      friendService.deleteFriend(this.friendToBeDeleted.friendCode).then(() => {
        this.$root.$bvToast.toast(`Erfolgreich!`, {
          title: 'Freund wurde entfernt!',
          autoHideDelay: 4000,
          variant: "success"
        });
        this.loadFriends();
      })
    },
    cancelFriendRequest(friendCode) {
      friendService.deleteFriend(friendCode).then(() => {
        this.loadFriends();
      })
    },
    resetDeleteFriend() {
      this.friendToBeDeleted = {};
    },
    hovered(friendCode) {
      this.hoveredList[friendCode] = !this.hoveredList[friendCode];
      this.hoveredList = utilsService.deepCopy(this.hoveredList);
    },
    showDelete(friendCode) {
      return this.hoveredList[friendCode];
    }
    ,
    hoveredFriendRequest(friendCode) {
      this.hoveredListRequest[friendCode] = !this.hoveredListRequest[friendCode];
      this.hoveredListRequest = utilsService.deepCopy(this.hoveredListRequest);
    },
    showDeleteRequest(friendCode) {
      return this.hoveredListRequest[friendCode];
    }
  }
}
</script>

<style scoped>
.username-or-code-input {
  position: fixed;
  bottom: 5px;
  width: 90%;
  left: 2.5%;
}
.username-or-code-input input {
  margin: 0;
}
</style>

